import type {MessageKey} from '/src/i18n/messages';

const ONE_TIME_PRODUCT_NAME = 'Plus One Week One time';
const REFERRAL_PRODUCT_NAME = 'Referral Plus';
const LIFETIME_PRODUCT_NAME = 'Plus Lifetime';
const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

export function isOneTimePass(productName?: string | null): boolean {
    return productName === ONE_TIME_PRODUCT_NAME || productName === REFERRAL_PRODUCT_NAME;
}

export function isStandaloneOneTimePass(productName?: string | null, subscriptionId?: string | null): boolean {
    return isOneTimePass(productName) && !subscriptionId?.startsWith('sub_');
}

/** The "N days left" line of the account menu: a plural message taking `count`. */
export function getNavbarDaysLeftMessage(productName?: string | null): MessageKey {
    return isOneTimePass(productName) ? 'account.menu.plusAccessDaysLeft' : 'account.menu.subscriptionDaysLeft';
}

export function getFullDaysLeft(endsAt?: string | null, now = Date.now()): number | null {
    if (!endsAt) return null;
    const end = new Date(endsAt).getTime();
    if (Number.isNaN(end)) return null;
    return Math.max(0, Math.floor((end - now) / MILLISECONDS_PER_DAY));
}

export function isLifetimeAccess(productName?: string | null): boolean {
    return productName?.trim() === LIFETIME_PRODUCT_NAME;
}
